/** Props for decorative / list images that must not starve Inertia navigation. */
export const DEFERRED_IMG_PROPS = {
  loading: "lazy",
  decoding: "async",
  fetchPriority: "low",
} as const
